import type { FC } from 'react';
import { ProductThumbnail, Text } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

export type ServiceType = keyof typeof serviceIcon;

export interface ProductServiceItemProps {
  'data-testid'?: string;
  className?: string;
  title: string;
  amount?: string;
  type: ServiceType;
  showText?: boolean;
}

export const serviceIcon = {
  warranty: 'il-product-warranty',
  recicambio: 'il-recycle',
  installation: 'il-installation-service',
  assembly: 'il-assembly-service'
} as const;

const ProductServiceItem: FC<ProductServiceItemProps> = ({
  'data-testid': dataTestId = 'paris-productserviceitem',
  title,
  amount,
  type,
  showText = true,
  className
}) => (
  <div
    data-testid={dataTestId}
    className={classNames('co-flex co-gap-3', className)}
  >
    <ProductThumbnail variant="icon" iconName={serviceIcon[type]} />
    {showText && (
      <div className="co-flex co-flex-col co-gap-0.5 co-py-1">
        <Text variant="body2" weight={600}>
          {title}
        </Text>
        <Text variant="caption" weight={500}>
          Cantidad: {amount}
        </Text>
      </div>
    )}
  </div>
);

export default ProductServiceItem;
